import { render, staticRenderFns } from "./RequestByModulePerDayInAMonthBarChart.vue?vue&type=template&id=8a20a72e&scoped=true&"
import script from "./RequestByModulePerDayInAMonthBarChart.vue?vue&type=script&lang=js&"
export * from "./RequestByModulePerDayInAMonthBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a20a72e",
  null
  
)

export default component.exports